module.exports = __webpack_public_path__ + "img/img-sarita-allen@3x.af8f5b4b.png";